// extracted by mini-css-extract-plugin
export default {"source":"Source_source__7QfDa"};